
export const initialState = {
  user: {
    jwt: '',
    details: {},
  },
  activeKosning: {},
  drawer: {
    mobileOpen: false,
  },
  atkvaediOptions: [
    {
      id: 1,
      lysing: "Atkvæði skilað í kassa"
    },
    {
      id: 2,
      lysing: "Atkvæði tekið með"
    },
    {
      id: 3,
      lysing: "Atkvæði greitt á heilbrigðisstofnun"
    },
    {
      id: 4,
      lysing: "Atkvæði greitt í heimahúsi"
    },
    {
      id: 5,
      lysing: "Atkvæði greitt í fangelsi"
    }
    // {
    //   id: 6,
    //   lysing: "Aðsent atkvæði"
    // },
  ],
};